import { environment } from '../../environments/environment';

const redirectHost = environment.webAppHost;
const OKTA_CLIENT_ID = environment.oktaClientId;
const OKTA_DOMAIN = environment.oktaDomain;

export function getOktaUrl(codeChallenge: string, state: string, nonce: string): string {
  return (
    `${OKTA_DOMAIN}oauth2/v1/authorize?` +
    `client_id=${OKTA_CLIENT_ID}&` +
    'response_type=code&' +
    'response_mode=query&' +
    'scope=openid  offline_access groups&' +
    `redirect_uri=${redirectHost + '/login/callback'}&` +
    `state=${state}&` +
    `nonce=${nonce}&` +
    `code_challenge_method=S256&code_challenge=${codeChallenge}`
  );
}
